<template>
    <div>
        <!-- <div id="main"></div> -->
        <vue-echarts id="chart5DimFollowProb" :option="option" ref="chart" class="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";

export default {
    name: 'horStackBarChart',
    data() {
        return {
        }
    },
    components: {
        VueEcharts,
    },
    props: {
        DimFollow: Object,
        // prefixAmount: String,
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
        millionShortNum(num) {
            if (num >= 1000000000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    1
                );
            }
            if (num >= 1000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    1
                );
            }
            if (num >= 1000000000000) {
                return this.globalNumDecFixed((num / 1000000000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 1);
            }
            if (num >= 1000000) {
                return this.globalNumDecFixed((num / 1000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 1);
            }
            return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        },
        millionShortString(num) {
            if (num >= 1000000000000000000000000) {
                return "ล้านล้านล้านล้าน";
            }
            if (num >= 1000000000000000000) {
                return "ล้านล้านล้าน";
            }
            if (num >= 1000000000000) {
                return "ล้านล้าน";
            }
            if (num >= 1000000) {
                return "ล้าน";
            }
            return '';
        }
    },
    mounted() {


      // setTimeout(function () {
      //     this.$nextTick(() => {
      //       this.$refs.chart.setOption(this.option);
      //     })
      // }.bind(this), 500)

      this.option.series[0].data = [
        this.DimFollow.prob_health.survivable,
        this.DimFollow.prob_family.survivable,
        this.DimFollow.prob_education.survivable,
        this.DimFollow.prob_occupation.survivable,
        this.DimFollow.prob_accessibility.survivable
      ];
      this.option.series[1].data = [
        this.DimFollow.prob_health.sufficient,
        this.DimFollow.prob_family.sufficient,
        this.DimFollow.prob_education.sufficient,
        this.DimFollow.prob_occupation.sufficient,
        this.DimFollow.prob_accessibility.sufficient
      ];
      this.option.series[2].data = [
        this.DimFollow.prob_health.sustainable,
        this.DimFollow.prob_family.sustainable,
        this.DimFollow.prob_education.sustainable,
        this.DimFollow.prob_occupation.sustainable,
        this.DimFollow.prob_accessibility.sustainable
      ];
      this.option.series[3].data = [
        this.DimFollow.prob_health.not_proceeded,
        this.DimFollow.prob_family.not_proceeded,
        this.DimFollow.prob_education.not_proceeded,
        this.DimFollow.prob_occupation.not_proceeded,
        this.DimFollow.prob_accessibility.not_proceeded
      ];

      this.$refs.chart.setOption(this.option);

    },
    computed: {
        option() {
            const vm = this;
            return {
                tooltip: {
                    trigger: 'axis',
                    confine: 'true',
                    name: {
                        show: false
                    },
                    textStyle: {
                        fontWeight: '400',
                    },
                    axisPointer: {
                        // Use axis to trigger tooltip
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    },
                    valueFormatter: (value) => this.globalNumDecFixed(value) + ' คน',
                    triggerOn: 'mousemove|click'
                },
                legend: {
                    show: false
                },
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: '300',
                    fontSize: '10px'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    top: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLabel: {
                        show: false,
                        formatter: function (value, index) {
                            return vm.millionShortNum(value);
                        }
                    },
                },
                yAxis: {
                    type: 'category',
                    data: ['สุขภาพ', 'ความเป็นอยู่', 'การศึกษา', 'รายได้', 'การเข้าถึงบริการรัฐ'],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#728196'
                        }
                    },
                    inverse: true
                },
                color: ["#4cb2f4",
                    "#5480a4",
                    "#0079b5",
                    "#e2e8f0"],
                series: [
                    {
                        name: 'อยู่รอด',
                        type: 'bar',
                        stack: 'total',
                        // label: {
                        //   show: true
                        // },
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.prob_health.survivable,
                        this.DimFollow.prob_family.survivable,
                        this.DimFollow.prob_education.survivable,
                        this.DimFollow.prob_occupation.survivable,
                        this.DimFollow.prob_accessibility.survivable]
                    },
                    {
                        name: 'พอเพียง',
                        type: 'bar',
                        stack: 'total',
                        // label: {
                        //   show: true
                        // },
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.prob_health.sufficient,
                        this.DimFollow.prob_family.sufficient,
                        this.DimFollow.prob_education.sufficient,
                        this.DimFollow.prob_occupation.sufficient,
                        this.DimFollow.prob_accessibility.sufficient]
                    },
                    {
                        name: 'ยั่งยืน',
                        type: 'bar',
                        stack: 'total',
                        // label: {
                        //   show: true
                        // },
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.prob_health.sustainable,
                        this.DimFollow.prob_family.sustainable,
                        this.DimFollow.prob_education.sustainable,
                        this.DimFollow.prob_occupation.sustainable,
                        this.DimFollow.prob_accessibility.sustainable]
                    },
                    {
                        name: 'ยังไม่ดำเนินการ',
                        type: 'bar',
                        stack: 'total',
                        // label: {
                        //   show: true
                        // },
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.prob_health.not_proceeded,
                        this.DimFollow.prob_family.not_proceeded,
                        this.DimFollow.prob_education.not_proceeded,
                        this.DimFollow.prob_occupation.not_proceeded,
                        this.DimFollow.prob_accessibility.not_proceeded]
                    },
                ]
            }
        },
    },
};
</script>

<style scoped>
.chart {
    top: 0px;
    max-height: 180px;
    height: 180px;
}

@media screen and (max-width: 1199.8px) {
    .chart {
        max-height: 150px;
        height: 150px;
    }
}
</style>
